export enum CookieNames {
  rxdAuthSession = 'rxd_auth_session',
  rxdAuthId = 'rxd_auth_id',
  ssoRefreshToken = 'sso_refresh_token',
}

export const defaultPathCookie = '/';
